const { default: getHighchartsBundle } = require("../lazy-bundles/load-highcharts-bundle");

/**
 * Stores all of the charts to be rendered on the Fund Listing page
 */
window.feCharts = {
    loadedCharts: [],
    currentChart: {
        chartTitle: "",
        dataSet: [],
        seriesName: "",
        color: "",
        xAxisTitle: "",
        yAxisTitle: "",
        tooltipSuffix: ""
    },

    translationKeys: {
        Performance: "_FundlistingLatam.Chart.Performance",
        PremiumOrDiscount: "_FundlistingLatam.Chart.PremiumOrDiscount",
        NavChart: "_FundlistingLatam.Chart.NavChart",
        PriceChart: "_FundlistingLatam.Chart.PriceChart",
        CumulativeChart: "_FundlistingLatam.Chart.CumulativeChart",
        HypotheticalGrowthChart: "_FundlistingLatam.Chart.HypotheticalGrowthChart",
        DownloadNAVHistory: "_FundlistingLatam.Chart.DownloadData",
        CHANGEDATERANGE: "_FundlistingLatam.Chart.CHANGEDATERANGE",
        Loading: "_FundlistingLatam.Chart.Loading",
        SinceInception: "_FundlistingLatam.Chart.SinceInception",
        NoDataForSelectedDateRange: "_FundlistingLatam.Chart.NoDataForSelectedDateRange",
        yAxisAccessibilityDescription_1: "_FundlistingLatam.Chart.yAxisAccessibilityDescription_1",
        yAxisAccessibilityDescription_2: "_FundlistingLatam.Chart.yAxisAccessibilityDescription_2",
        ten_years:  "_FundlistingLatam.Chart.10_Years",
        five_years: "_FundlistingLatam.Chart.5_Years",
        three_years: "_FundlistingLatam.Chart.3_Years",
        one_year: "_FundlistingLatam.Chart.1_Year",
        six_months: "_FundlistingLatam.Chart.6_Months",
        three_months: "_FundlistingLatam.Chart.3_Months",
        SelectDateRange: "_FundlistingLatam.Chart.SelectDateRange",
        Go: "_FundlistingLatam.Chart.Go",

        January: "_FundlistingLatam.Chart.Date.January",
        February: "_FundlistingLatam.Chart.Date.February",
        March: "_FundlistingLatam.Chart.Date.March",
        April: "_FundlistingLatam.Chart.Date.April",
        May: "_FundlistingLatam.Chart.Date.May",
        June: "_FundlistingLatam.Chart.Date.June",
        July: "_FundlistingLatam.Chart.Date.July",
        August: "_FundlistingLatam.Chart.Date.August",
        September: "_FundlistingLatam.Chart.Date.September",
        October: "_FundlistingLatam.Chart.Date.October",
        November: "_FundlistingLatam.Chart.Date.November",
        December: "_FundlistingLatam.Chart.Date.December",

        ShortJan: "_FundlistingLatam.Chart.Date.Short.Jan",
        ShortFeb: "_FundlistingLatam.Chart.Date.Short.Feb",
        ShortMar: "_FundlistingLatam.Chart.Date.Short.Mar",
        ShortApr: "_FundlistingLatam.Chart.Date.Short.Apr",
        ShortMay: "_FundlistingLatam.Chart.Date.Short.May",
        ShortJun: "_FundlistingLatam.Chart.Date.Short.Jun",
        ShortJul: "_FundlistingLatam.Chart.Date.Short.Jul",
        ShortAug: "_FundlistingLatam.Chart.Date.Short.Aug",
        ShortSep: "_FundlistingLatam.Chart.Date.Short.Sep",
        ShortOct: "_FundlistingLatam.Chart.Date.Short.Oct",
        ShortNov: "_FundlistingLatam.Chart.Date.Short.Nov",
        ShortDec: "_FundlistingLatam.Chart.Date.Short.Dec",

        Sunday: "_FundlistingLatam.Chart.Date.Sunday",
        Monday: "_FundlistingLatam.Chart.Date.Monday",
        Tuesday: "_FundlistingLatam.Chart.Date.Tuesday",
        Wednesday: "_FundlistingLatam.Chart.Date.Wednesday",
        Thursday: "_FundlistingLatam.Chart.Date.Thursday",
        Friday: "_FundlistingLatam.Chart.Date.Friday",
        Saturday: "_FundlistingLatam.Chart.Date.Saturday"
    },

    translations: {},

    setHighchartsTranslations() {
        Highcharts.setOptions({
            lang: {
                months: [
                    window.feCharts.translations[window.feCharts.translationKeys.January],
                    window.feCharts.translations[window.feCharts.translationKeys.February],
                    window.feCharts.translations[window.feCharts.translationKeys.March],
                    window.feCharts.translations[window.feCharts.translationKeys.April],
                    window.feCharts.translations[window.feCharts.translationKeys.May],
                    window.feCharts.translations[window.feCharts.translationKeys.June],
                    window.feCharts.translations[window.feCharts.translationKeys.July],
                    window.feCharts.translations[window.feCharts.translationKeys.August],
                    window.feCharts.translations[window.feCharts.translationKeys.September],
                    window.feCharts.translations[window.feCharts.translationKeys.October],
                    window.feCharts.translations[window.feCharts.translationKeys.November],
                    window.feCharts.translations[window.feCharts.translationKeys.December],
                ],
                shortMonths: [
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJan],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortFeb],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortMar],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortApr],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortMay],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJun],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortJul],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortAug],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortSep],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortOct],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortNov],
                    window.feCharts.translations[window.feCharts.translationKeys.ShortDec],
                ],
                weekdays: [
                    window.feCharts.translations[window.feCharts.translationKeys.Sunday],
                    window.feCharts.translations[window.feCharts.translationKeys.Monday],
                    window.feCharts.translations[window.feCharts.translationKeys.Tuesday],
                    window.feCharts.translations[window.feCharts.translationKeys.Wednesday],
                    window.feCharts.translations[window.feCharts.translationKeys.Thursday],
                    window.feCharts.translations[window.feCharts.translationKeys.Friday],
                    window.feCharts.translations[window.feCharts.translationKeys.Saturday],
                ]
            }
        });
    },

    /**
 * Renders the basic chart skeleton, but not the chart.
 *
 * @param {any} chartType
 * @param {any} row
 */
    rnChartArea: function (chartType, row, tickerGroup, displayTicker) {
        //Pass a display ticker when the Fund Ticker being displayed is different from the actual Fund Ticker being passed to the Chart Data API.
        displayTicker = displayTicker || row.ExpandableContent.Ticker;

        switch (chartType) {
            case "premium-discount":
                var tabIDprefix = "the-prem-tab-";
                var chartTitle = displayTicker + " Premium or Discount (bps): <span id='current-quarter'></span>";

                var downloadLink = "";

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                row.ExpandableContent.Quarters.forEach(function (e, i) {
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link premium-discount-quarter" id="' + e.Value + '-tab" data-quarter="' + e.Value + '" role="tab" aria-controls="Last11Year" aria-selected="">' + e.Name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = ''; //no date picker for premium discount
                break;
            case "price":
            case "growth-10k":
                var tabIDprefix = "the-tab-";
                var title = "Nav Chart";
                if (typeof tickerGroup === "string") {
                    title = tickerGroup.toLowerCase() === "index" ? "Price Chart" : title;
                }

                var chartTitle = displayTicker + " - " + title;

                var downloadLink = "<div class='expandable-download-link'><a class='font-weight-normal' href='" + row.ExpandableContent.DownloadUrl + "'>Download NAV History</a></div>";

                var inceptionDate = new Date(row.ExpandableContent.InceptionDate);

                var periods = feCharts.getPricePeriods(inceptionDate, row);

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                var activePeriodId = periods[periods.length - 1]?.id ?? "sinceInception";

                periods.forEach(function (e, i) {
                    var isActive = e.id === activePeriodId ? "active" : ""
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link price-period ' + isActive + '" id="' + row.ExpandableContent.Ticker + '-' + e.id + '-tab" data-start-date="' + e.startDate + '" role="tab" aria-selected="false">' + e.name + '</a></li>';
                });

                tabs += '</ul >';

                //var datePicker = '<div class="d-flex container justify-content-end">Fund Inception Date: ' + row.ExpandableContent.InceptionDate  + '</div>';
                var changeDateText = window.ve10kChartOverrides?.ChangeDateText ?? "CHANGE DATE RANGE";
                var dateFormatString = window.ve10kChartOverrides?.IsEuFund ? "(DD/MM/YYYY) - (DD/MM/YYYY)" : "(MM/DD/YYYY) - (MM/DD/YYYY)"

                var datePicker = '<div class="row d-flex justify-content-center"><div class="datepicker" id="daterange-' + row.ExpandableContent.Ticker + '-prices" ><span class="datepicker-date active-date active">' + dateFormatString +'</span><button class="datepicker-btn btn btn-link" data-inception-date="' + row.ExpandableContent.InceptionDate + '" id="date-' + row.ExpandableContent.Ticker + '-prices" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '" type="button">' + changeDateText +'</button></div></div>';

                break;
            default:
                console.error("Unknown chart type:" + chartType);
                return "";
        }

        var chartHeader = '<h4 class="mb-0" id="chart-title-' + row.ExpandableContent.Ticker + '">' + chartTitle + '</h4>' + downloadLink + '<div class="fund-explorer-table__graph row"> <div class="fund-explorer-table__graph-tab col-12"> <div class="tabs">';

        if (chartType == "growth-10k") {
            //we don't use a title nor do we use a download link for the growth of 10k chart area. Currently used only on fund pages.
            chartHeader = '<div class="fund-explorer-table__graph row"> <div class="fund-explorer-table__graph-tab col-12"> <div class="tabs">';
        }

        //var tabs is declated above.

        /* We are only rendering one tab and using JS to re-render the chart on the same tab, hence disabling the BS Tabs functionality. */
        var tabContent = '<div class="tabs__content tab-content"> <div class="tab-pane fade active show" id="' + tabIDprefix + row.ExpandableContent.Ticker + '" role="tabpanel"  aria-labelledby="nav-list-' + row.ExpandableContent.Ticker + '"> Loading... </div> </div >';

        var headerClose = '</div></div>';

        return chartHeader + tabs + tabContent + headerClose + datePicker;
    },


    loadData: function(renderContainer, ticker, chartType, quarter, startDate, endDate, blockID, isEuTicker, tooltipPrefix, chartValueText, noDataText, specialNoDataText) {
        /**
         * Guard clauses
         */

        if (typeof ticker != "string") return console.error("Can't load chart without ticker.");
        if (typeof chartType != "string") return console.error("Can't load chart without chart type.");
        if (typeof renderContainer != "string") return console.error("Can't load chart without a rendering container.");
        var url = "/Main/FundListingUs/GetChartData";
        var mkDates = "";
        var mkQuarter = "";
        var g10koptions = null;

        switch (chartType) {
        case "premium-discount":
            if (typeof quarter != "string") return console.error("Can't load chart without chart type.");
            mkQuarter = '"Quarter":"' + quarter + '",';
            break;
        case "price":
        case "PriceWithDecimal":
            if (typeof startDate == "undefined" || typeof endDate == "undefined")
                return console.error("Can't load chart without a starting and ending date.");
            mkDates = '"StartTime":"' + startDate + '","EndTime":"' + endDate + '",';
            break;
        case "growth-10k":
                if (typeof startDate == "undefined" || typeof endDate == "undefined") return console.error("Can't load chart without a starting and ending date.");
                if (typeof ve10kcharts == "undefined" || !blockID) return console.error("Can't load chart without 10k chart options object loaded or blockID.");
                g10koptions = ve10kcharts.find(x => x.blockId == blockID);
                if(!g10koptions) return console.error("Couldn't find 10k chart options object.");
            break;
        default:
            return console.error("Unknown chart type: " + chartType);
        }

        /*
         * For the Growth of 10k chart, where the API is slightly older.
         * */
        if (chartType == "growth-10k") {
            g10koptions.ajaxOptions.data.startDate = startDate;
            g10koptions.ajaxOptions.data.endDate = endDate;

            return $.ajax(g10koptions.ajaxOptions).done(async function (data, response) {
                feCharts.loadedCharts.push(await feCharts.processData({
                        ChartType: "growth-10k",
                        Ticker: data[0]?.name,
                        ChartData: data[0]?.data,
                        XAxisTitle: window["linechartoptions" + blockID]?.xAxis?.title?.text,
                        XAxisLabelsFormatter: isEuTicker ? window["linechartoptions" + blockID]?.xAxis?.labels?.formatter : null,
                        YAxisTitle: "",
                        YAxisLabelsFormatter: window["linechartoptions" + blockID]?.yAxis?.labels?.formatter,
                        TooltipPrefix: tooltipPrefix,
                        TooltipFormatterMethod: null,
                        TooltipFormatter: isEuTicker ? "euTooltip" : "",
                        responseData: data,
                        NoDataText: noDataText,
                        SpecialNoDataText: specialNoDataText
                    }, renderContainer));
            });

        }

    /**
     * All other charts continue here
     * */

    var mkTicker = '"Ticker":"' + ticker + '",';
        var mkChartType = '"ChartType":"' + chartType + '"';

        /**Payload needs to be in the string format required by Prabhu... */
        var payload = {
            'filterJson':
                "{" + mkTicker + mkDates + mkQuarter + mkChartType + "}"
        }

        //console.log(payload);

        $.post(url, payload).done(async function(data, response) {
            //console.log(data);
            if (typeof data.Result != "object" || !data.Result?.length) return console.error("The response was not expected.");
            feCharts.loadedCharts.push(await feCharts.processData(data.Result[0], renderContainer));
            feutils.spinner.hide();
        }).fail(feCharts.ajaxFail);

    },

    ajaxFail: function(e) {
        console.error("The response returned an error!");
        feutils.spinner.hide();
        console.log(e);
    },

    processData: async function(data, renderSlr) {
        if (typeof data != "object") return console.error("Chart details expected!");
        if (typeof data.ChartData === "undefined" || data.ChartData.length === 0) {
            /* There is no data */
            var noDataMessage = data.SpecialNoDataText
                ? '<div class="w-100 text-center text-primary my-6">' + (data.SpecialNoDataText ?? 'There is no data for the selected date range.') + '</div>'
                : '<div class="w-100 text-center text-primary my-6">' + (data.NoDataText ?? 'There is no data for the selected date range.') + '</div>';
            $(renderSlr).html(noDataMessage);
            return [];
        }

        var dataSet = [];
        data.ChartData.forEach(function(e, i) {
            var s = e.split(",");
            var date = Date.UTC(s[0], s[1], s[2], 4); /* UTC + 4 hours = ET */
            var val = Number(s[3]);
            val = isNaN(val) ? 0 : val;
            dataSet.push([date, val]);
        });
        var ChartData = {};

        //check if the dataset is less than 3 months
        var startDate = new Date(dataSet[0][0]);
        var endDate = new Date(dataSet[dataSet.length - 1][0]);
        var dateSpan = endDate - startDate;
        dateSpan = dateSpan < 1 ? dateSpan * -1 : dateSpan;
        var smallPeriod = (dateSpan < 1000 * 60 * 60 * 24 * 130); //Approx 130 days

        switch (data.ChartType) {
            case "premium-discount":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "%",
                    tooltipPrefix: "",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "price"
                }
                break;
            case "growth-10k":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    xAxisLabelsFormatter: data.XAxisLabelsFormatter,
                    yAxisTitle: data.YAxisTitle,
                    yAxisLabelsFormatter: data.YAxisLabelsFormatter,
                    tooltipSuffix: "",
                    tooltipPrefix: data.TooltipPrefix ?? window.ve10kChartOverrides?.CurrencySymbol ?? "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: data.TooltipFormatter ? data.TooltipFormatter : "price",
                    tooltipFormatterMethod: data.TooltipFormatterMethod,
                    responseData: data.responseData,
                    floatingLegend: true,
                    chartHeight: 450,
                }
                break;
            case "price":
            case "PriceWithDecimal":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "",
                    tooltipPrefix: "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "nav"
                }
                break;
            default:
                return console.error("Unidentified chart type: " + data.ChartType);
        }

        feCharts.currentChart = ChartData;
        return await feCharts.rnChart($(renderSlr)[0]);

    },

    activateTabListeners: function() {
        $('ul.chart-tabs').each(function(i, e) {
            var chartType = $(e).data('chart-type');
            var ticker = $(e).data('ticker');

            switch (chartType) {
            case "growth-10k":
                    //price chart is triggered by listening for a datepicker change. see growth-10k.js
                    break;
            case "premium-discount":
                var tabslr = "#tabs-for-" + ticker + " .premium-discount-quarter";
                    $(tabslr).click(function () {
                        feutils.spinner.show();
                        $(this).parent().parent().find('a.nav-link').removeClass('active');
                        $(this).addClass('active');
                    var quarter = $(this).data("quarter");
                    var container = "#the-prem-tab-" + ticker;
                    feCharts.loadData(container, ticker, chartType, quarter, false, false);
                    $('#chart-title-' + ticker + ' > #current-quarter').text(quarter);
                });
                break;
                case "price":
                    //price chart is triggered by listening for a datepicker change. see scripts.js
                break;
            default:
                return;
            }
        });

        $('.expandable-content-pane').on('shown.bs.collapse',
            function() {
                var activePriceElem = $(this).find('a.nav-link.price-period.active');
                $(this).find('a.nav-link.premium-discount-quarter').first().click();
                $(this).find('.datepicker-btn').trigger('apply.daterangepicker');
                //the first time make the "since inception" active again, regardless of daterangepicker removing it...
                if (activePriceElem.length === 1) {
                    window.setTimeout(function() {
                        activePriceElem.addClass("active");
                    }, 20)
                }
            }).on('hidden.bs.collapse', function() {
            //delete the chart
            $(this).find('.tab-pane.active').first().empty();
        });
    },

    //precision rounding
    mathRound: function(num) {
        var m = Number((Math.abs(num) * 100).toPrecision(15));
        return Math.round(m) / 100 * Math.sign(num);
    },


    rnChart: async function (containerElm) {
        //Enable standard markers for line charts, instead of the default symbols.
        Highcharts.seriesTypes.line.prototype.drawLegendSymbol = Highcharts.seriesTypes.column.prototype.drawLegendSymbol;

        var currentChart = feCharts.currentChart;
        var seriesSet = [];
        //first and default series
        seriesSet.push({
            name: currentChart.seriesName,
            data: currentChart.dataSet,
            color: currentChart.color
        })

        //growth of 10k has an additional series. Here we use a custom parsing algorithem to parse and add the data.
        if (feCharts.currentChart.responseData && feCharts.currentChart.responseData.length) {
            seriesSet = [];
            feCharts.currentChart.responseData.forEach((value, key) => {
                series = { data: [] };
                $.each(value, function (key, val) {
                    switch (key) {
                        case "name":
                            series.name = val;
                            break;
                        case "color":
                            series.color = val;
                            break;
                        case "showInLegend":
                            series.showInLegend = val;
                            break;
                        case "marker":
                            series.marker = {};
                            series.marker.enabled = val.enabled;
                            series.marker.symbol = val.symbol;
                            break;
                        default:
                            $.each(val, function (key, val) {
                                var d = val.split(",");
                                var x = Date.UTC(d[0], d[1], d[2]);
                                if (d[3] === 'null') {
                                    series.data.push([x, null]);
                                }
                                else {
                                    series.data.push([x, parseFloat(d[3])]);
                                }
                            });
                            break;
                    }
                });

                var getDivisor = function (total) {
                    return Math.min(Math.round(total / 400), 4) || 1;
                }

                //Manually sample out the data to target about 300-500 data points.
                //However the divisor is capped at 4 as we do not want to sample less than 1/4
                var lastitem = series.data[series.data.length - 1];
                var divisor = getDivisor(series.data.length);
                series.data = series.data.filter(function (e, i) { return (i % divisor) === 0 })
                series.data.push({
                    x: lastitem[0],
                    y: lastitem[1],
                    labelrank: 1000
                });

                seriesSet.push(series);
            });
            const customLineChartColours = feutils.veColors //window.ve10kChartOverrides?.IsEuFund ? feutils.veColors : ["#17468F", "#108A12"]
            seriesSet.forEach((e, i) => {
                seriesSet[i].color = customLineChartColours[i];
            });
        }
        //console.log("Test item", JSON.parse(ve10kChartOverrides.FullMonths))
        await getHighchartsBundle()

        if (window.ve10kChartOverrides?.IsEuFund) {
            Highcharts.setOptions({
                lang: {
                    decimalPoint: window.ve10kChartOverrides?.NumberDecimalSeparator,
                    thousandsSep: window.ve10kChartOverrides?.NumberGroupSeparator,
                    months: JSON.parse(window.ve10kChartOverrides?.FullMonths),
                    shortMonths: JSON.parse(window.ve10kChartOverrides?.ShortMonths),
                    weekdays: JSON.parse(window.ve10kChartOverrides?.WeekDays),
                    shortWeekdays: JSON.parse(window.ve10kChartOverrides?.ShortWeekdays),
                }
            });
        }
        return new Highcharts.Chart({
            chart: {
                renderTo: containerElm,
                type: 'line',
                height: currentChart.chartHeight ?? 350,
                backgroundColor: "rgba(0, 0, 0, 0)"
            },
            colors: [currentChart.color],
            title: {
                text: currentChart.chartTitle ? currentChart.chartTitle : undefined
            },
            xAxis: {
                lineColor: '#323232',
                labels: feCharts.getXAxisLabels(currentChart),
                title: {
                    text: currentChart.xAxisTitle,
                    style: {
                        color: '#323232'
                    }
                }
            },
            yAxis: {
                title: {
                    text: currentChart.yAxisTitle,
                    style: {
                        color: '#323232'
                    }
                },
                accessibility: {
                    description: 'trends in premiums and discounts for ' +
                        $('.hidden_data_feilds').find('.hdnNameClass').val() +
                        '. A negative number indicates that the funds shares sold at a discount to NAV; a positive number indicates the shares sold at a premium'
                },
                lineColor: '#323232',
                lineWidth: 1,
                labels: feCharts.getYAxisLabels(currentChart),
                maxPadding:0.2
            },
            tooltip: {
                formatter: currentChart.tooltipFormatterMethod ? currentChart.tooltipFormatterMethod : function () {
                    var y = currentChart.tooltipPrefix + feCharts.mathRound(this.y).toFixed(2) + currentChart.tooltipSuffix;
                    switch (currentChart.tooltipFormatter) {
                        case "nav":
                            return '<strong>' +
                                this.series.name +
                                '</strong><br/>' +
                                Highcharts.dateFormat('%a, %b %e %Y', this.x) +
                                ' : ' + y;
                        case "euTooltip":
                            y = currentChart.tooltipPrefix + Highcharts.numberFormat(this.y, 0, ',') + currentChart.tooltipSuffix;
                            return '<strong>' +
                                this.series.name +
                                '</strong><br/>' +
                                Highcharts.dateFormat('%a, %e %b %Y', this.x) +
                                ' : ' + y;
                        case "price":
                        default:
                            return '' +
                                this.series.name +
                                ' : ' +
                                Highcharts.dateFormat('%b %e %Y', this.x) +
                                '<br />' +
                                y;
                    }

                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                },
                series: {
                    marker: false
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -5,
                y: 20,
                floating: currentChart.floatingLegend ?? false,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            credits: {
                enabled: false
            },
            exporting: false,
            series: seriesSet,
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            y: 0,
                            width: '78%',
                        }
                    }
                }]
            }

        });
    },

    getXAxisLabels: function (currentChart){
       var xAxisLabelsOptions = {
            type: 'datetime',
            enabled: true,
            style: {
            fontSize: '11px',
                color: '#323232'
            },
            gridLineWidth: 0
        };

        //if (currentChart.xAxisLabelsFormatter) {
        //    xAxisLabelsOptions.formatter = currentChart.xAxisLabelsFormatter;
        //} else {
        //    xAxisLabelsOptions.format = currentChart.xAxisLabelFormat;
        //}
       xAxisLabelsOptions.format = currentChart.xAxisLabelFormat;
       return xAxisLabelsOptions;
    },

    getYAxisLabels: function (currentChart){
        var yAxisLabelsOptions = {
            overflow: 'justify',
            style: {
                color: '#323232'
            }
        };

        if(currentChart.yAxisLabelsFormatter){
            yAxisLabelsOptions.formatter = currentChart.yAxisLabelsFormatter;
        }else{
            yAxisLabelsOptions.format = currentChart.tooltipPrefix + '{value}';
        }

        return yAxisLabelsOptions;
    },

    getPricePeriods: function (inceptionDate, chartSettings) {
        var today = new Date();
        if (typeof inceptionDate != "object" || +inceptionDate > +today){ console.error("Need a valid inception date"); return [];}
        //var diff = today - inceptionDate;
        var periods = [];
        //var SinceInceptionText = ve10kChartOverrides?.SinceInceptionText ?? "Since Inception";

        var threeMonths = new Date(new Date().setMonth(new Date().getMonth() - 3));
        var sixMonths = new Date(new Date().setMonth(new Date().getMonth() - 6));
        var oneYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
        var threeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        var fiveYear = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
        var tenYear = new Date(new Date().setFullYear(new Date().getFullYear() - 10));

        switch(true) {
            case (+inceptionDate < +tenYear):
                if(!chartSettings.isSpa || chartSettings.isTenYearsLinkVisible) {
                    periods.push({
                        id: "tenYear",
                        name: window.ve10kChartOverrides?.TenYearText ?? "10 Years",
                        startDate: tenYear
                    });
                }
            case (+inceptionDate < +fiveYear):
                if(!chartSettings.isSpa || chartSettings.isFiveYearsLinkVisible) {
                    periods.push({
                        id: "fiveYear",
                        name: window.ve10kChartOverrides?.FiveYearText ?? "5 Years",
                        startDate: fiveYear
                    });
                }
            case (+inceptionDate < +threeYear):
                if(!chartSettings.isSpa || chartSettings.isThreeYearsLinkVisible) {
                    periods.push({
                        id: "threeYear",
                        name: window.ve10kChartOverrides?.ThreeYearText ?? "3 Years",
                        startDate: threeYear
                    });
                }
            case (+inceptionDate < +oneYear):
                if(!chartSettings.isSpa || chartSettings.isOneYearLinkVisible) {
                    periods.push({
                        id: "oneYear",
                        name: window.ve10kChartOverrides?.OneYearText ?? "1 Year",
                        startDate: oneYear
                    });
                }
            case (+inceptionDate < +sixMonths):
                if(!chartSettings.isSpa || chartSettings.isSixMonthLinkVisible) {
                    periods.push({
                        id: "sixMonths",
                        name: window.ve10kChartOverrides?.SixMonthText ?? "6 Months",
                        startDate: sixMonths
                    });
                }
            case (+inceptionDate < +threeMonths):
                if(!chartSettings.isSpa || chartSettings.isThreeMonthLinkVisible) {
                    periods.push({
                        id: "threeMonths",
                        name: window.ve10kChartOverrides?.ThreeMonthText ?? "3 Months",
                        startDate: threeMonths
                    });
                }
        }

        periods.reverse();

        if(!chartSettings.isSpa || chartSettings.isInceptionLinkVisible) {
            periods.push({
                id: "sinceInception",
                name: window.ve10kChartOverrides?.IsEuFund && window.ve10kChartOverrides?.SinceInceptionText ? window.ve10kChartOverrides?.SinceInceptionText : "Since Inception " + inceptionDate.toLocaleDateString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric"
                }),
                startDate: inceptionDate
            });
        }

        return periods;

    }


}